module.exports = __webpack_public_path__ + "img/swarmlogo.4892584e.svg";